import styled, { keyframes } from "styled-components";
import { HTMLAttributes } from "react";
import Colors from "../global/Colors";

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
`;

const StyledSkeleton = styled.div<{ $colorMode?: "light" | "dark" }>`
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  background-color: ${({ $colorMode }) => 
    $colorMode === "dark" ? Colors.grey8 : Colors.grey2};
  border-radius: 0.375rem;
`;

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  colorMode: "light" | "dark";
}

function Skeleton({ className, colorMode, ...props }: SkeletonProps) {
  return <StyledSkeleton className={className} $colorMode={colorMode} {...props} />;
}

export { Skeleton };